import Reflux from 'reflux';
import PopoverActions from 'flux/actions/PopoverActions';
import { Map } from 'immutable';
import BaseMixin from 'flux/stores/BaseMixin';
import SingleVisibleMixin from 'flux/stores/SingleVisibleMixin';

/**
 * PopoverStore
 *
 * Keeps track popover state
 *
 */
export default Reflux.createStore({
  listenables: [PopoverActions],

  mixins: [BaseMixin, SingleVisibleMixin],

  init() {
    this.setState(Map());
    this.namespaces = {};
  },

  /**
   * Hide the popover
   * @param  {[type]} key    The popover key/id
   * @param  {[type]} always if set to true, always hide, even if 'locked'
   * @return [type]          [description]
   */
  onHide(key, always) {
    if (!always && (this.getInState('locked') || !key)) return;

    this.setVisibility(key, false);
  },

  onShow(key) {
    if (this.getInState('locked')) return;

    this.setVisibility(key, true);

    this._lock();

    setTimeout(() => this._unlock(), 300);
  },

  onHideGroup(namespace) {
    const state = this.getState();

    this.setStateAndTrigger(
      state.map((v, k) => {
        if (k.indexOf(namespace + '.') >= 0) return false;
        return v;
      }),
    );
  },

  _lock() {
    this.setInState('locked', true);
  },

  _unlock() {
    this.setInState('locked', false);
  },
});
